import { httpClient } from '@/api/http-client'
import { CompanyPayload } from '@/types'
import { useMutation, UseMutationOptions } from '@tanstack/react-query'
import { AxiosError } from 'axios'

type Params = {
  companyKey: string
  companyData: CompanyPayload
}

export const useUpdateCompany = (
  options?: UseMutationOptions<void, AxiosError, Params>,
) => {
  const updateCompany = async ({
    companyKey,
    companyData,
  }: Params): Promise<void> => {
    const response = await httpClient('accounting-dealer').put(
      `v3/company/${companyKey}`,
      companyData,
    )
    return response.data
  }

  return useMutation({
    mutationFn: updateCompany,
    ...options,
  })
}
